module.exports = __webpack_public_path__ + "assets/img/active_community_l2.5fd1b565.png";